import { logout } from './auth';

// Helper function to handle API responses
export const handleApiResponse = async (response) => {
  if (response.status === 401) {
    logout();
    throw new Error('Unauthorized access. Please login again.');
  }

  if (!response.ok) {
    let errorData = {};
    try {
      errorData = await response.json();
    } catch (e) {
      // Ignore if error response has no JSON body
    }
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }

  if (response.status === 204) {
    return null;
  }

  const text = await response.text();
  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
};

// Helper function to handle API errors
export const handleApiError = (error) => {
  console.error('API Error:', error);

  // Only logout if it is strictly an Unauthorized error
  if (error.message && error.message.includes('Unauthorized access')) {
    logout();
    return;
  }

  // You can add more specific error handling here
  // For example, show toast notifications, etc.
  throw error;
};

// Wrapper for API calls with consistent error handling
export const apiCall = async (apiFunction, ...args) => {
  try {
    const response = await apiFunction(...args);
    return await handleApiResponse(response);
  } catch (error) {
    handleApiError(error);
  }
};

// Utility to check if user is authenticated
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const authStatus = localStorage.getItem('isAuthenticated') === 'true';
  return !!(token && authStatus);
};

// Utility to get user data
export const getUserData = () => {
  const userData = localStorage.getItem('user');
  return userData ? JSON.parse(userData) : null;
};

// Utility to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}; 